import { observer } from 'mobx-react';
import ModalStore from '../../../../Modal/Store';
import Modal from '../../../../Modal';
import Form from './Form';
import InvitationStore from '../Store/InvitationStore';

interface Props {
  modalStore: ModalStore;
  store: InvitationStore;
}
function EditInvitationModal({ store, modalStore }: Props) {
  switch (modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <Modal
          close={modalStore.close}
          title={''}
          modalWidth="w-2/5 overflow-y-auto"
          customBackgroundCssClasses="bg-teal-100 opacity-60"
        >
          <Form store={store} modalStore={modalStore} />
        </Modal>
      );
  }
}

export default observer(EditInvitationModal);
